import { Typography, Box, useTheme, Fade } from '@mui/material';
import { IconWriting } from 'components/icons';

import { useRef, useState } from 'react';
import { useIntl } from 'react-intl';
//@ts-ignore : sin types
import ReactSignatureCanvas from '@rubricae/react-signature-canvas';

export type SignBoxProps = {
    signCollector: Function;
};

const DrawSignBox = ({ signCollector }: SignBoxProps) => {
    const theme = useTheme();
    const intl = useIntl();
    const ref = useRef<ReactSignatureCanvas>(null);

    const [advice, setAdvice] = useState<boolean>(true);

    return (
        <>
            <Box
                onMouseDown={() => setAdvice(false)}
                onTouchStart={() => setAdvice(false)}
                onMouseUp={() => signCollector(ref.current)}
                onTouchEnd={() => signCollector(ref.current)}
                sx={{
                    position: 'relative',
                    width: '100%',
                    height: '240px',
                    '> canvas': {
                        background: '#F5F5F5',
                        borderRadius: '8px'
                    }
                }}
            >
                <Fade in={advice}>
                    <Box
                        sx={{
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center'
                        }}
                    >
                        <IconWriting
                            stroke={1}
                            style={{
                                color: theme.palette.primary.dark,
                                marginBottom: '12px',
                                width: '36px',
                                height: '36px'
                            }}
                        />
                        <Typography variant="subtitle1">{intl.formatMessage({ id: 'CREA_TU_FIRMA_AQUI' })}</Typography>
                    </Box>
                </Fade>
                <ReactSignatureCanvas penColor="rgba(0,0,139,0.80)" canvasProps={{ width: 480, height: 240 }} ref={ref} />
            </Box>
        </>
    );
};

export default DrawSignBox;
